/**
 * Local tracking for supplier
 */
import { useSupplierStore } from '@dashboardApp/stores/SupplierStore.js';
import { jsonapiStore } from '@dashboardApp/store';

export const performSupplierLocalTracking = () => {
	
	const store = jsonapiStore();
	const supplierStore = useSupplierStore();

	function viewed() {
		if (supplierStore.isOwner) {
        	return;
    	}
    	store.post([
            { _jv: { type: 'supplier_view' } }, 
            { url: `supplier/tracking/viewed/${supplierStore.supplier?._jv.id}` }
        ]).then((data) => {

    	});
	}

	/**
	 * @param {Array} suppliers - Supplier IDs
	 */
	function includedInResults(view, suppliers) {
		store.post([
            { 
            	_jv: { type: 'supplier' },
        	}, 
            { 
            	url: `supplier/tracking/included_in_results/${view}`,
            	data: { suppliers }
            }
        ]);
	}
	
	/**
	 * @param {Number} id - The supplier live ID
	 */
	function tracked(id, entity, location) {
		store.post([
            { 
            	_jv: { type: 'supplier_general_track' },
            	entity,
            	location
            }, 
            { url: `supplier/tracking/tracked/${id}` }
        ]);
	}

	return {
		viewed, includedInResults, tracked
	}

}